// require('abortcontroller-polyfill/dist/abortcontroller-polyfill-only');
const extend = require('../util/Extend')
const abortableFetch = require('../util/fetch').fetch;
const IHttpRequest = require('./IHttpRequest');
// const abortableFetch = ('signal' in new Request('')) ? window.fetch : fetch.fetch;


//
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new Error(response.statusText);
        error.response = response;
        throw (error);
    }
}

/**
 * 
 * @constructor
 * @classdesc 请求对象
 * @alias G.base.HttpRequest
 * @returns {G.base.HttpRequest} 实例化对象
 */
class HttpRequest extends IHttpRequest {
    constructor(opts) {
        super(opts);
    }

    /**
     * @private
     * @param method
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     * @param headers
     * @returns {Promise<any>}
     * @private
     */
    _request(method, url, responseType, data, contentType, headers) {
        return new Promise(async(resolve, reject) => {
            try {
                let opts = {};
                opts.method = method;
                //header
                opts.headers = {};
                contentType = contentType || 'application/json';
                opts.headers['Content-Type'] = contentType;
                extend(opts.headers, headers || {});
                const tempType = contentType.split(';')[0];
                //body
                if (method == 'POST') {
                    switch (tempType) {
                        case 'application/json':
                            {
                                opts.body = JSON.stringify(data);
                                break;
                            }
                        case 'application/x-www-form-urlencoded':
                            {
                                opts.body = this._parseFormParams(data);
                                break;
                            }
                        default:
                            {
                                opts.body = data;
                                break;
                            }
                    }
                } else {
                    if (url.indexOf('?') < 0) {
                        url += '?';
                    }
                    url += '&';
                    url += this._parseFormParams(data);
                }
                let response = await abortableFetch(url, opts);
                responseType = responseType || 'json';
                checkStatus(response);
                let result = null;
                switch (responseType) {
                    case 'json':
                        {
                            result = response.json();
                            break;
                        }
                    case 'blob':
                        {
                            result = response.blob();
                            break;
                        }
                    case 'text':
                        {}
                    case 'document':
                        {}
                    default:
                        {
                            result = response.text();
                        }
                }
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    }

    _parseFormParams(obj) {
        let paramStr = '';
        for (let k in obj) {
            paramStr += k;
            paramStr += '=' + obj[k];
            paramStr += '&';
        }
        return paramStr;
    }

    /**
     * Get 请求
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     */
    get(url, responseType, data, contentType, headers) {
        return this._request('GET', url, responseType, data, contentType, headers);
    }

    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     */
    post(url, responseType, data, contentType, headers) {
        return this._request('POST', url, responseType, data, contentType, headers);
    }


    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     */
    put(url, responseType, data, contentType, headers) {
        return this._request('PUT', url, responseType, data, contentType, headers);
    }


    /**
     *
     * @param url
     * @param responseType
     * @param data
     * @param contentType
     */
    delete(url, responseType, data, contentType, headers) {
        return this._request('DELETE', url, responseType, data, contentType, headers);
    }
}

module.exports = HttpRequest;